import React from 'react'
// import { Link } from 'react-router-dom';
import "../assets/css/project.css"
import "../assets/css/main.css"

class RentalHome extends React.Component {
  constructor() {
    super();
    this.state = {
      rentals: [

        {
          _id: 0,
          title: "Anime Quotes Generator",
          category: "Using React js",
          image: "https://i.ibb.co/z2BdbRk/Screenshot-2023-03-30-154143.png",
          description: "An anime quotes website is a platform that gathers and showcases some of the most memorable and inspiring quotes from anime series and movies. These quotes are typically taken from the dialogue of characters in anime and manga, and are often poignant, insightful, or humorous.",
          demoLink: "https://animequotesig.netlify.app/",
          codeLink: "https://github.com/Amitgajare2/animequotes"
        },

        {
          _id: 1,
          title: "Note App",
          category: "Using React js",
          image: "https://i.ibb.co/YNVhHw1/Screenshot-2023-02-24-170732.png",
          description: "a notes app in React and integrate the app with localStorage. The main functions of our app will include creating a note, setting a character limit, deleting notes, and saving them in localStorage. ",
          demoLink: "https://quicknotes9673.netlify.app/",
          codeLink: "https://github.com/Amitgajare2/noteapp"
        },
      {
        _id: 2,
        title: "Naruto Landing Page",
        category: "Using Javascript",
        image: "https://i.ibb.co/QcpKWYv/naruto.png",
        description: "Naruto Shippuden is one of my favourite animes. so I thought why not, AnimeNow is a hypothetical website for anime lovers.",
        demoLink: "https://amitgajare2.github.io/Naruto/",
        codeLink: "https://github.com/Amitgajare2/Naruto"
      },
      {
        _id: 3,
        title: "Html Code Editor",
        category: "Using Javascript",
        image: "https://i.ibb.co/9cqNY2G/htmled.png",
        description: "Write and run HTML, CSS and JavaScript code using our online editor. Our HTML editor updates the webview automatically in real-time as you write code.",
        demoLink: "https://freeuto.blogspot.com/",
        codeLink: "https://github.com/Amitgajare2/htmleditor"
      },
      {
        _id: 4,
        title: "Password Manager",
        category: "Using Python",
        image: "https://i.ibb.co/ZH7wGsq/pass.png",
        description: "PassSave a password manager Light weight CLI Based Password Manager To Store Your Important Password.",
        demoLink: "https://www.youtube.com/watch?v=GrRd92RnB7c",
        codeLink: "https://github.com/Amitgajare2/PasswordManager"
      }
    ]
    }
  }
  render() {
    const { rentals } = this.state;

    const newTabs=url=>{
      window.open(url);
    }

    return (
      <div className="my-project-box">
        <div className="head-box">
          <h3>My Projects</h3> 
          <div className="main-box">
            {
              rentals.map((rental) => {
                return (
                  <div className='cards'>
                    <div key={rental._id} className="col-md-3">
                      <div className="card-img">
                        <img
                          className="card-img-top"
                          src={rental.image}
                          alt={rental.title} />
                      </div>
                        <div className="card-body">
                          <h6 className="card-subtitle">
                            {rental.category}
                          </h6>
                          <h5 className="card-title">
                            {rental.title}
                          </h5>
                          <p className="card-text">
                            {rental.description}
                          </p>
                          <div className="buttom-btn">
                            {/* <Link to={{ pathname:`${rental.demoLink}`}} target="_blank">Demo</Link> */}                                             
                            <button className='btn' onClick={()=> newTabs(rental.demoLink)}>Demo</button>
                            <button className='btn' onClick={()=> newTabs(rental.codeLink)}>Code</button>
                          </div>
                        </div>
                      
                    </div>
                  </div>
                )
              })
            }

          </div>
        </div>
      </div>
    )
  }
}

export default RentalHome;